import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AppContextProvider } from "./context/AppContext";
import React, { useContext, Suspense } from "react";
import Home from "./pages/Auth/Home";
import Profile from "./pages/Auth/Profile";
import SignIn from "./pages/Auth/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Loader from "./components/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from "./pages/Error";
import { I18nextProvider } from "react-i18next";
import i18n from "./config/i18n";

import Customer from "./pages/User/Customer/Index";
import CustomerView from "./pages/User/Customer/View";
import Activity from "./pages/User/Activity";
import Faq from "./pages/Faq/Index";

// import Content from "./pages/Content/Index";
// import ContentView from "./pages/Content/View";
// import ContentEdit from "./pages/Content/Edit";
// import PrivacyPolicy from "./pages/Content/PrivacyPolicy";

import Report from "./pages/Report/Index";
import ReportView from "./pages/Report/View";
import Post from "./pages/Post/Index";
import PostView from "./pages/Post/View";
import ClipType from "./pages/ClipType/Index";
import SkillTag from "./pages/SkillTag/Index";
import Role from "./pages/Role/Index";
import PointRule from "./pages/PointRule/Index";
import Level from "./pages/Level/Index";
import Badge from "./pages/Badge/Index";
import Reward from "./pages/Reward/Index";
import Redemption from "./pages/Redemption/Index";
import Group from "./pages/Group/Index";
import LeaderBoard from "./pages/LeaderBoard/Index";
import CoachAcademy from "./pages/CoachAcademy";
import Tournaments from "./pages/Tournaments/index";
import ViewTournament from "./pages/Tournaments/ViewTournament";

import Discount from "./pages/Discount/Index";
import Notification from "./pages/Notification/Index";
import ActivityNotification from "./pages/ActivityNotification/Index";

import EmailTemplate from "./pages/EmailTemplate/Index";
import EmailTemplateView from "./pages/EmailTemplate/View";
import EmailTemplateEdit from "./pages/EmailTemplate/Edit";

import { USERTYPE } from "./constants/conts";
import ChangePassword from "./pages/Auth/ResetPassword";
import UserManager from "./pages/User/UserManager";
import AdminManager from "./pages/User/AdminManager";
import AdminView from "./pages/User/AdminView";
import SessionManager from "./pages/User/SessionManager";
import Integration from "./pages/Integration/Index";
import Maintenance from "./pages/Maintenance/Index";
import Policy from "./pages/Policy/Index";
import PublicPolicyView from "./pages/Policy/PublicView";
import PublicSupport from "./pages/Support/PublicSupport";
import Music from "./pages/Music/index";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  return (
    <AuthProvider>
      <AppContextProvider>
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={<Loader />}>
            <BrowserRouter>
              <ScrollToTop />
              <ToastContainer closeOnClick={false} />
              <AppRoutes />
            </BrowserRouter>
          </Suspense>
        </I18nextProvider>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {
  const { userProfile, isLoggedIn } = useContext(AuthContext);

  return (
    <Routes>
      {/* <Route path="/static/view/:slug" element={<PrivacyPolicy />} /> */}
      <Route exact path="/reset-password/:token" element={<ChangePassword />} />
      <Route
        path="/privacy-policy"
        element={<PublicPolicyView type="PRIVACY" />}
      />
      <Route
        path="/terms-conditions"
        element={<PublicPolicyView type="TERMS" />}
      />
      <Route path="/support" element={<PublicSupport />} />
      <Route path="/login" element={<SignIn />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            {" "}
            <Layout />{" "}
          </PrivateRoute>
        }
      >
        {/* Auth Routes */}
        <Route exact path="/" element={<Home />} />
        <Route exact path="/admin/dashboard" element={<Home />} />
        <Route exact path="/profile" element={<Profile />} />

        {/* Admin Routes */}
        <Route exact path="/admin/admin-role" element={<Customer />} />
        <Route exact path="/admin/user-manager" element={<UserManager />} />
        <Route
          exact
          path="/admin/admin-account-manager"
          element={<AdminManager />}
        />
        <Route
          exact
          path="/admin/user-manager/view/:id"
          element={<CustomerView />}
        />
        <Route
          exact
          path="/admin/admin-account-manager/view/:id"
          element={<AdminView />}
        />
        <Route exact path="/user/activity/:id" element={<Activity />} />

        {/* Skills & Meta Data Tags Routes */}
        <Route exact path="/admin/tag-manager" element={<SkillTag />} />
        <Route exact path="/admin/role-manager" element={<Role />} />
        <Route exact path="/admin/clip-type-manager" element={<ClipType />} />
        <Route exact path="/admin/point-manager" element={<PointRule />} />
        <Route exact path="/admin/level-manager" element={<Level />} />
        <Route exact path="/admin/badge-manager" element={<Badge />} />
        <Route exact path="/admin/reward-manager" element={<Reward />} />
        <Route
          exact
          path="/admin/redemption-manager"
          element={<Redemption />}
        />
        <Route exact path="/admin/leaderboard-manager" element={<LeaderBoard />} />
        <Route exact path="/admin/tournaments" element={<Tournaments />} />
        <Route exact path="/admin/tournaments/view/:id" element={<ViewTournament />} />
        <Route exact path="/admin/coach-manager" element={<CoachAcademy />} />
        <Route exact path="/admin/academy-manager" element={<CoachAcademy />} />

        {/* Report Routes */}
        <Route exact path="/admin/report-manager" element={<Report />} />
        <Route exact path="/discount" element={<Discount />} />

        <Route exact path="/report/view/:id" element={<ReportView />} />
        {/* Post Routes */}
        <Route exact path="/admin/post-manager" element={<Post />} />
        <Route exact path="/admin/group-manager" element={<Group />} />
        <Route exact path="/post/view/:id" element={<PostView />} />

        {/* Faq Routes */}
        <Route exact path="/faq" element={<Faq />} />

        {/* Notification Routes */}
        <Route exact path="/notification" element={<Notification />} />

        {/* Session Routes */}
        <Route
          exact
          path="/admin/session-manager"
          element={<SessionManager />}
        />

        {/* Activity Notification Routes */}
        <Route
          exact
          path="/admin/notification-manager"
          element={<ActivityNotification />}
        />

        {/* Setting Routes */}
        <Route
          exact
          path="/admin/integration-manager"
          element={<Integration />}
        />
        <Route
          exact
          path="/admin/maintenance-manager"
          element={<Maintenance />}
        />
        <Route exact path="/admin/policy-manager" element={<Policy />} />
        <Route exact path="/admin/music-manager" element={<Music />} />

        {/* Content Routes */}
        {/* <Route exact path="/content" element={<Content />} /> */}
        {/* <Route exact path="/content/update/:slug?" element={<ContentEdit />} /> */}
        {/* <Route exact path="/content/view/:slug" element={<ContentView />} /> */}

        {/* EmailTemplate Routes */}
        <Route exact path="/email-template" element={<EmailTemplate />} />
        <Route
          exact
          path="/email-template/update/:id?"
          element={<EmailTemplateEdit />}
        />
        <Route
          exact
          path="/email-template/view/:id"
          element={<EmailTemplateView />}
        />
      </Route>

      <Route path="*" element={<Error />} />
    </Routes>
  );
};

const Layout = () => {
  return (
    <>
      {" "}
      <Outlet />{" "}
    </>
  );
};

export default App;
